<template>
  <div class="main-ct" :key="key">
    <template v-for="channel in channels">
      <channel-metrics-chart
        class="channel-metric-ct"
        v-if="chartsData[channel]"
        :chart-type="chartType"
        :key="channel"
        :title="$t(`CampaignAnalytics_Channel_${channel}`)"
        :icon="`dashboard_${channel}`"
        :chart-data="chartsData[channel] || {}"
        :height="
          getChannelHeight((chartsData[channel] || {}).datasets || []).length
        "
      />
    </template>
    <p class="no-data-ct" v-if="!channels.length">
      {{ $t('RestList_NoData') }}
    </p>
  </div>
</template>

<script>
import { projectEndpoint } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import ChannelMetricsChart from '@/common/components/ChannelMetricsChart.vue'
import AnalyticsMixin from '@/modules/campaign-manage/mixins/AnalyticsMixin'

export default {
  name: 'AllChannels',
  components: { ChannelMetricsChart },
  mixins: [AnalyticsMixin],
  props: {
    model: {
      type: Object,
      required: true
    },
    analyticsDateRange: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      key: null,
      allSupportedChannels: [
        'email',
        'mobile_push',
        'sms',
        'web_push',
        'inapp',
        'onsite',
        'inbox'
      ],
      reportData: {}
    }
  },
  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      if (!this.channels.length) {
        return
      }

      RestApi(
        projectEndpoint({
          method: 'get',
          url: `campaigns/${this.$route.query.id}/analytics/engagement-chart-data`,
          params: {
            startDate: this.analyticsDateRange.date_from,
            endDate: this.analyticsDateRange.date_to,
            channels: this.channels
          }
        })
      )
        .then(({ data }) => {
          this.reportData = data.data
          this.$nextTick(() => {
            this.key = new Date().getTime()
          })
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  },
  computed: {
    channels() {
      let channels = this.allSupportedChannels.filter(
        ch => (this.model[ch] || 0) === 1
      )
      if (this.model.ios_push || this.model.android_push) {
        channels.push('mobile_push')
      }

      return channels
    }
  },

  watch: {
    analyticsDateRange: {
      handler: function() {
        this.fetchData()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.main-ct {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}

.no-data-ct {
  text-align: center;
  color: #909399;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/analytics/AllChannels.vue